module.exports = __webpack_public_path__ + "a4af87cdfb7eca2f704da9044350606e.pdf";